import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const AwaitingShippingLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-awaiting-shipping' */ './AwaitingShipping'),
  {
    fallback: <LoadingComponent />,
  }
);

export default AwaitingShippingLoadable;
